import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';
import { IntegrationsService } from '@app/features/company-settings/integrations/services/integrations.service';
import { CommonService } from '@app/services';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: '[app-cs-toggleuserpreference]',
    templateUrl: './cs-toggleuserpreference.component.html',
    styleUrls: ['./cs-toggleuserpreference.component.css'],

})

export class CsToggleuserpreferenceComponent implements OnInit {

    @Input() dragEnabled: boolean = false;
    @Input('screenName') screenName: string = '';
    @Input('labelName') labelName: string = 'Try out the new view screen';
    @Input('oldUrl') oldUrl: string = '';
    @Input('newUrl') newUrl: string = '';
    @Input('preferenceValue') preferenceValue: any = '';
    @Input('betaPropertyName') betaPropertyName: any = '';
    @Output() selected_preference = new EventEmitter<any>();

    @Input('integrationsUI') integrationsUI: boolean = false;

    toggleSwitch: boolean = false;
    showFeedbackForm: boolean;
    count: number = 0;
    feedbackEmitter$: Subject<string> = new Subject<string>();
    canSubmit: boolean;

    reason = '';
    comments = '';
    reasons: any = [
        {
            'id': 1,
            'description': 'I don’t have time to get used to it right now'
        },
        {
            'id': 2,
            'description': 'There are missing features stopping me move across'
        },
        {
            'id': 3,
            'description': 'There are bugs stopping me move across'
        },
        {
            'id': 4,
            'description': 'I just don’t like it - change is hard!'
        },
        {
            'id': 5,
            'description': 'I think the new design is worse - I have constructive feedback'
        }
    ];
    select2Config = {
        minimumResultsForSearch: -1
    };

    constructor(private commonService: CommonService,
                private integrationsService: IntegrationsService) {
    }

    ngOnInit() {
        if (this.preferenceValue) {
            this.toggleSwitch = true;
        } else {
            this.toggleSwitch = false;
        }
    }

    setUserPropertyViewPreference(savedFeedback?: boolean) {
        this.count++
        if (!this.integrationsUI || savedFeedback) {
            if (savedFeedback) {
                this.toggleSwitch = true;
            }
            let data = {};
            data['screenName'] = this.screenName;
            if ( this.preferenceValue) {
                this.toggleSwitch = false;
                data['columnValue'] = 0;
                this.commonService.saveUserNewUIPreference(data)
                    .subscribe(resp => {
                        window.location.href = this.oldUrl;
                    }, error => {
                        console.log('err', error);
                    });
            } else if ( !this.preferenceValue ) {
                this.toggleSwitch = true;
                data['columnValue'] = 1;
                this.commonService.saveUserNewUIPreference(data)
                    .subscribe(resp => {
                        window.location.href = this.newUrl;
                    }, error => {
                        console.log('err', error);
                    });
            }
        } else {
            this.showFeedbackForm = true;
            this.toggleSwitch = false;
        }

        if (this.count == 2 && this.integrationsUI && !savedFeedback) {
            this.hideFeedbackForm();
        }
    }

    hideFeedbackForm() {
        if (this.showFeedbackForm) {
            this.showFeedbackForm = false;
            this.toggleSwitch = true;
            this.comments = '';
            this.reason = '';
            this.count = 0;
            this.canSubmit = false;
        }
    }

    submitFeedbackForm() {

        if (this.canSubmit) {
            let data = {
                betaPropertyName: this.betaPropertyName,
                reason: this.reason,
                feedback: this.comments,
                uiScreen: this.screenName
            };
            this.integrationsService.updateSwitchDisableNotes(data).subscribe(() => {
                this.setUserPropertyViewPreference(true);
                this.showFeedbackForm = false;
            }, () => {
                return false;
            });
        } else {
            return false;
        }
    }

    validateFeedback(event) {
        this.canSubmit = false;
        this.reason = '';
        if(event) {
            const selectedEvent = event;
            const selectedReason = this.reasons.find(x=> x.id == selectedEvent);
            this.reason = selectedReason['description'];
            this.canSubmit = this.reason.trim() !== '';
        }
    }
}
